import React from 'react'
import { UserProgressData } from './contexts/userProgress'
import { UserAuth } from '../../backend/firebaseConfig/authProvider';

function BacScreen() {

    const { problemsSolved } = UserProgressData() || {};
    const { loggedIn } = UserAuth();

    const sections = [
        {
            title: "While",
            lessons: [
                { title: "Puteri ale lui k", link: "/problems/bac/Puteri ale lui k", icon: "fa-solid fa-circle-check" },
                { title: "Valori distincte", link: "/problems/bac/Valori distincte", icon: "fa-solid fa-circle-check" },
                { title: "Inversarea pozitiilor cifrelor impare", link: "/problems/bac/Inversarea pozitiilor cifrelor impare", icon: "fa-solid fa-circle-check" },
                { title: "Prelucrarea cifrelor pare", link: "/problems/bac/Prelucrarea cifrelor pare", icon: "fa-solid fa-circle-check" },
                { title: "Produsul cifrelor impare", link: "/problems/bac/Produsul cifrelor impare", icon: "fa-solid fa-circle-check" },
                { title: "Numere cu cifre impare intr-un interval", link: "/problems/bac/Numere cu cifre impare intr-un interval", icon: "fa-solid fa-circle-check" },
                { title: "Termenii sirului mai mici sau egali cu y", link: "/problems/bac/Termenii sirului mai mici sau egali cu y", icon: "fa-solid fa-circle-check" },

            ]
        },
        {
            title: "Tablouri unidimensionale",
            lessons: [
                { title: "Cea mai mare suma de k termeni", link: "/problems/bac/Cea mai mare suma de k termeni", icon: "fa-solid fa-circle-check" },
                { title: "Verificarea numerelor crescatoare", link: "/problems/bac/Verificarea numerelor crescatoare", icon: "fa-solid fa-circle-check" },
                { title: "Cifra maxima si nr de aparitii", link: "/problems/bac/Cifra maxima si nr de aparitii", icon: "fa-solid fa-circle-check" },
                { title: "Determinarea numerelor cu aparitii multiple", link: "/problems/bac/Determinarea numerelor cu aparitii multiple", icon: "fa-solid fa-circle-check" },
                { title: "Rearanjarea elementelor", link: "/problems/bac/Rearanjarea elementelor", icon: "fa-solid fa-circle-check" },
                { title: "Sir paritar", link: "/problems/bac/Sir paritar", icon: "fa-solid fa-circle-check" },
                { title: "Scara crescatoare", link: "/problems/bac/Scara crescatoare", icon: "fa-solid fa-circle-check" },
                { title: "Secventa paritara", link: "/problems/bac/Secventa paritara", icon: "fa-solid fa-circle-check" },
                { title: "Suma in functie de paritate", link: "/problems/bac/Suma in functie de paritate", icon: "fa-solid fa-circle-check" },
                { title: "Pereche asemenea", link: "/problems/bac/Pereche asemenea", icon: "fa-solid fa-circle-check" },
                { title: "Numar munte", link: "/problems/bac/Numar munte", icon: "fa-solid fa-circle-check" },
                { title: "Interclasare", link: "/problems/bac/Interclasare", icon: "fa-solid fa-circle-check" },
                { title: "Interclasare2", link: "/problems/bac/Interclasare2", icon: "fa-solid fa-circle-check" },
                { title: "Targ de jucarii", link: "/problems/bac/Targ de jucarii", icon: "fa-solid fa-circle-check" },
                { title: "Interclasare X", link: "/problems/bac/Interclasare X", icon: "fa-solid fa-circle-check" },
                { title: "Numarul lipsa", link: "/problems/bac/Numarul lipsa", icon: "fa-solid fa-circle-check" },
                { title: "Cifre descrescatoare", link: "/problems/bac/Cifre descrescatoare", icon: "fa-solid fa-circle-check" },
                { title: "Sub-numar", link: "/problems/bac/Sub-numar", icon: "fa-solid fa-circle-check" },
                { title: "Inlocuire maxim", link: "/problems/bac/Inlocuire maxim", icon: "fa-solid fa-circle-check" },
                { title: "Pachete de carti", link: "/problems/bac/Pachete de carti", icon: "fa-solid fa-circle-check" },
                { title: "Clasament", link: "/problems/bac/Clasament", icon: "fa-solid fa-circle-check" },
                { title: "Q interogari", link: "/problems/bac/Q interogari", icon: "fa-solid fa-circle-check" },
                { title: "Q interogari2", link: "/problems/bac/Q interogari2", icon: "fa-solid fa-circle-check" },
                { title: "P Puteri", link: "/problems/bac/P Puteri", icon: "fa-solid fa-circle-check" },
                { title: "Progresie R", link: "/problems/bac/Progresie R", icon: "fa-solid fa-circle-check" },
                { title: "Scriere zecimala", link: "/problems/bac/Scriere zecimala", icon: "fa-solid fa-circle-check" },
                { title: "Secvente", link: "/problems/bac/Secvente", icon: "fa-solid fa-circle-check" },
                { title: "Capacitate maxima", link: "/problems/bac/Capacitate maxima", icon: "fa-solid fa-circle-check" },
                { title: "Subsiruri", link: "/problems/bac/Subsiruri", icon: "fa-solid fa-circle-check" },
                { title: "Interval X Y", link: "/problems/bac/Interval X Y", icon: "fa-solid fa-circle-check" },


            ]
        }, {
            title: "Matrici",
            lessons: [
                { title: "Matrice cu valori diferite", link: "/problems/bac/Matrice cu valori diferite", icon: "fa-solid fa-circle-check" },
                { title: "Matrice cu sume diferite pe linii si coloane", link: "/problems/bac/Matrice cu sume diferite pe linii si coloane", icon: "fa-solid fa-circle-check" },
                { title: "Generarea unei matrice cu numere pare", link: "/problems/bac/Generarea unei matrice cu numere pare", icon: "fa-solid fa-circle-check" },
                { title: "Produs sub diagonala secundara", link: "/problems/bac/Produs sub diagonala secundara", icon: "fa-solid fa-circle-check" },
                { title: "Eliminarea diagonalei secundare", link: "/problems/bac/Eliminarea diagonalei secundare", icon: "fa-solid fa-circle-check" },
                { title: "Coloana minimului", link: "/problems/bac/Coloana minimului", icon: "fa-solid fa-circle-check" },
                { title: "Simetrica", link: "/problems/bac/Simetrica", icon: "fa-solid fa-circle-check" },
                { title: "Innisiparea unei plaje", link: "/problems/bac/Innisiparea unei plaje", icon: "fa-solid fa-circle-check" },
                { title: "Eliminarea diagonalei principale", link: "/problems/bac/Eliminarea diagonalei principale", icon: "fa-solid fa-circle-check" },
                { title: "Multiplii pe diagonala principala", link: "/problems/bac/Multiplii pe diagonala principala", icon: "fa-solid fa-circle-check" },
                { title: "Elemente situate pe linia k", link: "/problems/bac/Elemente situate pe linia k", icon: "fa-solid fa-circle-check" },
                { title: "Produs pe diagonala secundara", link: "/problems/bac/Produs pe diagonala secundara", icon: "fa-solid fa-circle-check" },
                { title: "Produs maxim", link: "/problems/bac/Produs maxim", icon: "fa-solid fa-circle-check" },
                { title: "Conturul matricei", link: "/problems/bac/Conturul matricei", icon: "fa-solid fa-circle-check" },
                { title: "Conturul matricei2.0", link: "/problems/bac/Conturul matricei2.0", icon: "fa-solid fa-circle-check" },
                { title: "Interschimbare minima", link: "/problems/bac/Interschimbare minima", icon: "fa-solid fa-circle-check" },
                { title: "Suma coloanelor k", link: "/problems/bac/Suma coloanelor k", icon: "fa-solid fa-circle-check" },
                { title: "Linii si coloane de suma egala", link: "/problems/bac/Linii si coloane de suma egala", icon: "fa-solid fa-circle-check" },
                { title: "Generare sir Fibonacci2.0", link: "/problems/bac/Generare sir Fibonacci2.0", icon: "fa-solid fa-circle-check" },
                { title: "Medie aritmetica sub diagonala principala", link: "/problems/bac/Medie aritmetica sub diagonala principala", icon: "fa-solid fa-circle-check" },
                { title: "Generare matrice 1", link: "/problems/bac/Generare matrice 1", icon: "fa-solid fa-circle-check" },
                { title: "Generare matrice 2", link: "/problems/bac/Generare matrice 2", icon: "fa-solid fa-circle-check" },
                { title: "Generare matrice 3", link: "/problems/bac/Generare matrice 3", icon: "fa-solid fa-circle-check" },
                { title: "Generare matrice 4", link: "/problems/bac/Generare matrice 4", icon: "fa-solid fa-circle-check" },
                { title: "Generare matrice 5", link: "/problems/bac/Generare matrice 5", icon: "fa-solid fa-circle-check" },
                { title: "Generare matrice 6", link: "/problems/bac/Generare matrice 6", icon: "fa-solid fa-circle-check" },
                { title: "Generare matrice 7", link: "/problems/bac/Generare matrice 7", icon: "fa-solid fa-circle-check" },
            ]
        }, {
            title: "Subprograme",
            lessons: [
                { title: "Suma numerelor pare", link: "/problems/bac/Suma numerelor pare", icon: "fa-solid fa-circle-check" },
                { title: "Patratul numerelor prime", link: "/problems/bac/Patratul numerelor prime", icon: "fa-solid fa-circle-check" },
                { title: "Suma si numarul de cifre", link: "/problems/bac/Suma si numarul de cifre", icon: "fa-solid fa-circle-check" },
                { title: "Cifra cu proprietate de medie aritmetica", link: "/problems/bac/Cifra cu proprietate de medie aritmetica", icon: "fa-solid fa-circle-check" },
                { title: "Fractii ireductibile", link: "/problems/bac/Fractii ireductibile", icon: "fa-solid fa-circle-check" },
                { title: "Numar minim cu cifra maxima", link: "/problems/bac/Numar minim cu cifra maxima", icon: "fa-solid fa-circle-check" },
                { title: "Inlocuire secventa", link: "/problems/bac/Inlocuire secventa", icon: "fa-solid fa-circle-check" },
                { title: "Parcele de arie egala", link: "/problems/bac/Parcele de arie egala", icon: "fa-solid fa-circle-check" },
                { title: "Major impar", link: "/problems/bac/Major impar", icon: "fa-solid fa-circle-check" },
                { title: "Schimb", link: "/problems/bac/Schimb", icon: "fa-solid fa-circle-check" },
                { title: "Rest", link: "/problems/bac/Rest", icon: "fa-solid fa-circle-check" },
                { title: "Cub perfect", link: "/problems/bac/Cub perfect", icon: "fa-solid fa-circle-check" },
                { title: "Divizori primi la putere impara", link: "/problems/bac/Divizori primi la putere impara", icon: "fa-solid fa-circle-check" },
                { title: "Impar oglindite", link: "/problems/bac/Impar oglindite", icon: "fa-solid fa-circle-check" },

            ]
        }, {
            title: "Siruri de caractere",
            lessons: [
                { title: "Eliminarea consoanelor", link: "/problems/bac/Eliminarea consoanelor", icon: "fa-solid fa-circle-check" },
                { title: "Formatarea numerelor de telefon", link: "/problems/bac/Formatarea numerelor de telefon", icon: "fa-solid fa-circle-check" },
                { title: "Cuvinte de n litere", link: "/problems/bac/Cuvinte de n litere", icon: "fa-solid fa-circle-check" },
                { title: "Vocala prietena", link: "/problems/bac/Vocala prietena", icon: "fa-solid fa-circle-check" },
                { title: "Cautare prenume", link: "/problems/bac/Cautare prenume", icon: "fa-solid fa-circle-check" },
                { title: "Primele k cuvinte", link: "/problems/bac/Primele k cuvinte", icon: "fa-solid fa-circle-check" },

            ]
        },]

    return (
        <>
            {
                loggedIn ? (
                    <div className="accordion accordion-flush" id="accordionFlushExample">
                        {sections.map((section, sectionIndex) => {

                            return (
                                <div key={sectionIndex} className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapse${sectionIndex}`} aria-expanded="false" aria-controls={`flush-collapse${sectionIndex}`}>
                                            {section.title}
                                        </button>
                                    </h2>

                                    <div id={`flush-collapse${sectionIndex}`} className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                        {section.lessons.map((lesson, lessonIndex) => {
                                            const isSolved = problemsSolved.includes(lesson.title);

                                            return (
                                                <div key={lessonIndex} className="accordion-body" style={{ display: 'flex' }}>
                                                    <div className="icon-container">
                                                        <i className={lesson.icon}
                                                            style={{ color: isSolved ? 'green' : 'grey' }}
                                                        ></i>


                                                        {lessonIndex !== section.lessons.length - 1 && <div className="vertical-line" style={{ backgroundColor: `${isSolved ? 'green' : 'grey'}` }}></div>}

                                                    </div>

                                                    <a style={{ textDecoration: 'none', marginLeft: '10px' }} href={lesson.link}>
                                                        {lesson.title}
                                                    </a>

                                                </div>
                                            );
                                        })}
                                    </div>

                                </div>
                            )



                        })}
                    </div>


                ) : (
                    <div style={{ marginTop: '100px' }}>
                        <h1 className='home-container' style={{ color: 'white' }}>Trebuie sa te loghezi!</h1 >
                    </div >
                )
            }

        </>

    )
}

export default BacScreen